// extracted by mini-css-extract-plugin
export var buttonsContainer = "CancelSubscriptionConfirmation_buttonsContainer__Z8yTP";
export var container = "CancelSubscriptionConfirmation_container__3eNin";
export var info = "CancelSubscriptionConfirmation_info__lcCEW";
export var title = "CancelSubscriptionConfirmation_title__qrQEg";